function FormText(props: any) {
  if (props.hidden) return <></>;
  return (
    <div className={props.className ? props.className : "EditForm"}>
      <label className="EditLabel">{props.title}</label>
      <div className="EditInputHolder">
        <input {...props} />
      </div>
    </div>
  );
}

export function FormTextArea(props: any) {
  return (
    <div className={props.className ? props.className : "EditForm"}>
      <label className="EditLabel">{props.title}</label>
      <div className="EditInputHolder EditInputArea">
        <textarea rows={props.rows ? props.rows : "3"} {...props} />
      </div>
    </div>
  );
}

export default FormText;
